import React, {useEffect} from "react";
import TableProductsShipment from "../components/Tables/ProductsShipment/TableProductsShipment";
import FilterProductsShipment from "../components/Tables/ProductsShipment/FilterProductsShipment";
import SetProductsByXlsx from "../components/Tables/ProductsShipment/Action/SetProductsByXlsx";
import DownloadProductsAsXlsx from "../components/Tables/ProductsShipment/Action/DownloadProductsAsXlsx";
import {useAppDispatch, useAppSelector} from "../redux/hooks";
import {getFeedOptionsData} from "../redux/feeds/actions";

const ProductsShipment: React.FC = () => {
    let rowData = [
        {
            sku: 'sku',
            barcode: '213123123123',
            name: 'Product 1',
            shipment: '2',
            inStock: '2',
            stocksPR: '2',
            acceptance: '2',
            discrepancy: '2',
        },
        {
            sku: 'sku',
            barcode: '213123123123',
            name: 'Product 1',
            shipment: '2',
            inStock: '2',
            stocksPR: '2',
            acceptance: '2',
            discrepancy: '2',
        },
    ]

    const dispatch = useAppDispatch();

    const {sellerId, feedOptions} = useAppSelector(({sellers, feeds}) => ({
        sellerId: sellers.currentSeller.info.data?.id,
        feedOptions: feeds.feed,
        feeds: feeds.feed.data.data,
    }));

    useEffect(() => {
        if(sellerId) {
            dispatch(getFeedOptionsData(sellerId) as any);
        }
    }, [sellerId, feedOptions.options.isNeedUpdateData])

    console.log(feedOptions.options.data)

    return (
        <div className="p-3">
            <div className="flex flex-col md:flex-row justify-between">
                <div className="mt-4 md:mt-0 w-full max-w-full overflow-hidden">
                    <nav className="flex justify-end mb-3">
                        <ul className="md:flex gap-4">
                            <li>
                                <SetProductsByXlsx />
                            </li>
                            <li>
                                <DownloadProductsAsXlsx />
                            </li>
                        </ul>
                    </nav>
                    <div className="flex flex-col md:flex-row gap-4 justify-between mt-0">
                        <FilterProductsShipment />
                        <TableProductsShipment data={rowData} />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ProductsShipment;